import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import { useNavigate } from "react-router-dom"
import ModuleRainOfWins from "./promotion_modules/ModuleRainOfWins"
import useAppPromotionTheme from "../hooks/useAppPromotionTheme"

export default function RainOfWins({ isLightMode }) {
  const isAppPromo = useAppPromotionTheme(isLightMode)
  const navigate = useNavigate()
  const [activeModal, setActiveModal] = useState("")
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  const modalComponents = {
    "Rain Of Wins": ModuleRainOfWins,
  }

  const data = promotionsData.find((promo) => promo.title === "Rain Of Wins")

  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  const handleRainOfWins = () => {
    if (!isLoggedIn) {
      window.location.href = "/promotion"
    } else {
      setActiveModal("Rain Of Wins")
    }
  }

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> Rain Of Wins </title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a
                href={
                  isAppPromo
                    ? "/promotion/".replace("/promotion", "/app-promotion")
                    : "/promotion/"
                }
              >
                Promotions
              </a>
              /<span> {data.title} </span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH${data.title}`}
              />
              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.class}
                  </div>
                  <h1> Rain Of Wins </h1>
                  <h2> Weekly Bet Tournament </h2>
                  <div className="promotion-tnc-period">
                    <strong> Event Period: </strong>
                    <span> June 1 (12PM) - June 29 (12PM) </span>
                  </div>
                </div>
                <div className="promotion-tnc-mechanic-content">
                  <strong> Terms & Conditions </strong>
                  {isLoggedIn && !isAppPromo && (
                    <div className="promotion-tnc-btn-wrapper">
                      <button
                        className="promotion-cta-btn"
                        onClick={handleRainOfWins}
                      >
                        Leaderboard
                      </button>
                    </div>
                  )}
                  <ol>
                    <li> Only CQ9 slot games are included. </li>
                    <li> Points are based on real wagers. </li>
                    <li>
                      {" "}
                      Bonus applies only once per day upon reaching ₱500 total
                      CQ9 wagers.{" "}
                    </li>
                    <li> Rankings reset weekly after cut-off. </li>
                    <li>
                      {" "}
                      Prizes are credited within the same day (Monday 3PM).{" "}
                    </li>
                    <li> No wagering requirement on weekly prizes. </li>
                  </ol>

                  <strong>Scoring System</strong>
                  <strong>Main Points</strong>
                  <ul>
                    <li>₱1 bet = 1 point</li>
                    <li>
                      The more you play CQ9 slots, the more points you earn.
                    </li>
                  </ul>

                  <strong>Bonus Points</strong>
                  <ul>
                    <li>
                      {" "}
                      <b>Additional 100 bonus points</b> per day when a player
                      reaches at least ₱500 total CQ9 bets within the day
                    </li>
                    <li>Can only be earned once per player per day</li>
                  </ul>
                  <strong> Prize Crediting </strong>
                  <ul>
                    <li>
                      {" "}
                      TOP 20 Winners will be credited every Monday at
                      3:00PM{" "}
                    </li>
                    <li>
                      {" "}
                      Credits will be automatically added to FGH winners with no
                      wagering requirement.{" "}
                    </li>
                  </ul>
                  <div className="table-wrapper">
                    <table
                      className="promotion-tnc-table"
                      style={{ minWidth: "0" }}
                    >
                      <thead>
                        <th> Rank </th>
                        <th> Free Credits </th>
                        <th> Total </th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1st</td>
                          <td>₱5,000</td>
                          <td>₱5,000</td>
                        </tr>
                        <tr>
                          <td>2nd</td>
                          <td>₱3,000</td>
                          <td>₱3,000</td>
                        </tr>
                        <tr>
                          <td>3rd</td>
                          <td>₱2,000</td>
                          <td>₱2,000</td>
                        </tr>
                        <tr>
                          <td>4-5</td>
                          <td>₱1,000</td>
                          <td>₱2,000</td>
                        </tr>
                        <tr>
                          <td>6-10</td>
                          <td>₱750</td>
                          <td>₱3,750</td>
                        </tr>
                        <tr>
                          <td>11–20</td>
                          <td>₱300</td>
                          <td>₱3000</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {!isAppPromo && (
                    <div className="promotion-tnc-cta">
                      <a
                        href="/slots/?provider=CQ9"
                        className="promotion-cta-btn"
                        style={{ cursor: "pointer" }}
                      >
                        Play Now
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {ActiveModal && <ActiveModal closeModal={() => setActiveModal("")} />}
    </>
  )
}
